import React, {Component} from 'react'
import propTypes from 'prop-types'
import {prefix} from 'helpers/component'
import EditableField from '../editableField'
import {setAutoFocusField} from 'helpers/fields'
import './editableListField.scss'

class EditableFieldList extends Component {
  constructor(props) {
    super(props)
    this.getClass = prefix('editableFieldList-')
  }

  render() {
    const {fields, onChange, validateState, autoFocusDelay, enableAutoFocus} = this.props
    setAutoFocusField(fields, enableAutoFocus)
    return (
      <div className={this.getClass('container')}>
        {fields.map(field =>
          <EditableField
            autoFocusDelay={autoFocusDelay}
            field={field}
            key={field.key}
            onChange={onChange}
            subField={field.subField}
            validateState={validateState}
          />
        )}
      </div>
    )
  }
}

EditableFieldList.propTypes = {
  autoFocusDelay: propTypes.number,
  enableAutoFocus: propTypes.bool,
  fields: propTypes.arrayOf(propTypes.shape({
    active: propTypes.bool,
    autoFocus: propTypes.bool,
    dataType: propTypes.string.isRequired,
    formFieldClassName: propTypes.string,
    key: propTypes.string.isRequired,
    label: propTypes.oneOfType([
      propTypes.string,
      propTypes.object,
    ]),
    mandatory: propTypes.bool,
    order: propTypes.number,
    readOnly: propTypes.bool,
    subField: propTypes.object,
  })).isRequired,
  onChange: propTypes.func,
  validateState: propTypes.bool,
}

EditableFieldList.defaultProps = {
  enableAutoFocus: true,
  validateState: false,
}

export default EditableFieldList
